import React from 'react';
import { ProjectContext } from '../projects/ProjectContext';
import SectionHeader from '../common/SectionHeader';
import PendingProjects from './PendingProjects';
import CurrentUser from '../CurrentUser';

class HomePage extends React.Component {
  render() {
    return (
      <React.Fragment>
        <SectionHeader title="Home" />
        <CurrentUser render={currentUser =>
          currentUser ? (
            <ProjectContext.Provider value={{ returnPath: "/home" }}>
              <PendingProjects user={currentUser} />
            </ProjectContext.Provider>
          ) : null} />
      </React.Fragment>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/home/HomePage.js